import { useConditionsToDisplayCard } from '@/domains/productDiscovery/Listings/hooks/useConditionsToDisplayCard';
import { useCategory } from '@/domains/productDiscovery/Listings/pages/Category/hooks/category';
import { useMassLanding } from '@/domains/productDiscovery/Listings/pages/MassLanding/hooks/massLanding';
import { useSearch } from '@/productDiscovery/Listings/pages/Search/hooks/search';

import type { Guide } from '../interfaces/InListingAdvice.model';

const useGuide = (
  guides?: Guide[],
  ignoreCategoryFilter = false,
): Guide | undefined => {
  const canDisplayListingAdvice =
    useConditionsToDisplayCard(ignoreCategoryFilter);

  if (canDisplayListingAdvice && guides && guides.length > 0) {
    return guides[0];
  }
  return undefined;
};

export const useCategoryGuide = (): Guide | undefined =>
  useGuide(useCategory()?.metadata?.advice?.guides);

export const useMassLandingGuide = (): Guide | undefined =>
  useGuide(useMassLanding()?.metadata?.advice?.guides);

export const useSearchGuide = (): Guide | undefined =>
  useGuide(useSearch()?.metadata?.advice?.guides, true);
